import { HugeIcon } from './HugeIcon';
import type { HugeIconData } from './HugeIcon.types';

/**
 * Reorder-handle glyph from the CV list redesign: three left-aligned rules with
 * the last one at half length. It has no equivalent in the icon set, so the
 * paths live here and render through HugeIcon (native + web).
 */
const dragHandleLines: HugeIconData = [
  [
    'path',
    {
      d: 'M4 6H20',
      key: '0',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.5',
    },
  ],
  [
    'path',
    {
      d: 'M4 12H20',
      key: '1',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.5',
    },
  ],
  [
    'path',
    {
      d: 'M4 18H12',
      key: '2',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeWidth: '1.5',
    },
  ],
];

interface DragHandleIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export function DragHandleIcon({
  size = 20,
  color,
  strokeWidth = 2,
}: DragHandleIconProps) {
  return (
    <HugeIcon
      icon={dragHandleLines}
      size={size}
      color={color}
      strokeWidth={strokeWidth}
    />
  );
}
